<script>
import {UContextMenu} from 'uloc-vue'
import ListMenu from './list-menu-site'

export default {
  name: 'ContextMenuSiteItem',
  props: ['site'],
  data () {
    return {
      atualizando: false
    }
  },
  computed: {},
  methods: {
  },
  components: {ListMenu, UContextMenu}
}
</script>

<template>
  <u-context-menu ref="context" class="erp-context-menu">
    <list-menu @abrir="$emit('abrir')" />
  </u-context-menu>
</template>
